import type { PropsWithChildren } from 'react';

import { routeLogin } from '@/auth/constants/authSettings';
import { getSession } from '@/auth/AuthSession';
import useAuth from '@/auth/useAuth';
import { Navigate, useLocation } from 'react-router';
import SuspenseLoader from '@/components/loaders/SuspenseLoader';

const SecureRoute = ({ children }: PropsWithChildren) => {
	const { isAuthenticated } = useAuth();
	const location = useLocation();
	const redirectPath = encodeURIComponent(location.pathname + location.search);

	if (!isAuthenticated()) {
		return <Navigate to={`${routeLogin}?r=${redirectPath}`} replace />;
	}

	// Check if user has a group (userGroupId)
	const session = getSession();
	if (session && session.isLoggedIn && !session.userGroupId) {
		// User is authenticated but has no group, redirect to no-space page
		return <Navigate to="/no-space" replace />;
	}

	return <SuspenseLoader>{children}</SuspenseLoader>;
};

export default SecureRoute;
